var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTestIcon = function SvgTestIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-62.000000, -235.000000)",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5,215 C48.8,215 49,215.2 49,215.5 L49,215.5 L49,217.5 C49,217.8 48.8,218 48.5,218 L48.5,218 L48,218 L48,223.4 C50.3,224.2 52,226.4 52,229 C52,232.3 49.3,235 46,235 C42.7,235 40,232.3 40,229 C40,226.4 41.7,224.2 44,223.4 L44,223.4 L44,218 L43.5,218 C43.2,218 43,217.8 43,217.5 L43,217.5 L43,215.5 C43,215.2 43.2,215 43.5,215 L43.5,215 Z M59.5,215 C59.8,215 60,215.2 60,215.5 L60,215.5 L60,217.5 C60,217.8 59.8,218 59.5,218 L59.5,218 L59,218 L59,231.5 C59,232.9 57.9,234 56.5,234 C55.1,234 54,232.9 54,231.5 L54,231.5 L54,218 L53.5,218 C53.2,218 53,217.8 53,217.5 L53,217.5 L53,215.5 C53,215.2 53.2,215 53.5,215 L53.5,215 Z M50,229 L42,229 C42,231.2 43.8,233 46,233 C48.2,233 50,231.2 50,229 L50,229 Z",
    id: "test"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTestIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/test-icon.8a6e7ed9.svg";
export { ForwardRef as ReactComponent };